import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { SonicFacility } from '../../../common/classes/SonicFacility';

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postUpdateFacility
 *
 * Update facility data from  page.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param args The key-value object of the string or image to be updated.
 * @returns Updated facility.
 */

export const postUpdateFacility = async (
  auth_token: string,
  args: { [key: string]: string | File }
) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(args)) {
    let key_name = key;
    if (key.includes("sonic_imgs")) {
      key_name = "sonic_imgs[]";
    }
    if (key.includes("sonic_delete_imgs")) {
      key_name = "sonic_delete_imgs[]";
    }

    if (value instanceof File) {
      formData.append(key_name, value, value.name);
    } else {
      formData.append(key_name, value);
    }
  }

  try {
    const res = await axios.post(getAPIRoot(APIRoutes.post.facility), formData, {
      headers: {
        "X-Sonic-Auth": auth_token,
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.data.result === false) return null;

    const e = res.data.message.facility;
    const facility = SonicFacility.parseFromAPIResponse(e);

    return facility;
  } catch (e) {
    return e.message;
  }
};
